/**
 * all filters
 */
app.directive("listFilters",function(){
    
   return {
     scope:{
         
         filterCallback:"=",
         symbol:"@"
         
     },controller:function($scope,_$filter){
         
        this.filterCallback=$scope.filterCallback;
        this.models=[]; 
         
         
        this.addModel=function(model){
                
           this.models.push(model);
           
        };
        
        //returns all models for filters
        this.getModels=function(){
          
            return this.models;
        };
        
        
        /*
         * Checks if filters was used
         */
        this.areClear=function(){
            
            var elements=this.getModels();
            var result=true;
            
            for (var key in elements){
                
                //date condition was added because isEmpty give true on date object with 00 on hour
                result=result&&(_.isEmpty(elements[key].value) && !_.isDate(elements[key].value));
                
            }
            
            return result;
        };
        
        //clear all values
        this.clear=function(){
            
            var elements=this.getModels();
            
            for (var key in elements){
                
                elements[key].value=null;//clear value
            }
            
        };
        
        
        if (typeof $scope.symbol!="undefined")
        _$filter.add($scope.symbol,this);
     }
       
       
   };
    
});


